import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Div } from '../../layouts';
import { CMS } from '../../utils/CMS';
import { Dropdown } from '../../components/Dropdown/Dropdown';
import { PaxSelectorDesktopEl } from './PaxSelectorDesktop.style';
import { ConnectedPaxSelectorContent } from './Content';
import { totalPax } from '../../redux/currentSearch/selectors';
import buttonClassNames from '../SearchButton/buttonClassNames';
import { ButtonDefault } from '../../components';

export const PaxSelectorDesktop = ({ pax, disabled }) => {
    const { t } = useTranslation();
    const node = React.useRef(null);
    const [isOpen, setOpen] = React.useState(false);
    const arrowClassName = classNames({
        'odf-input-icon odf-icon': true,
        'odf-icon-arrow-up odf-z-index-3': isOpen,
        'odf-icon-arrow-down': !isOpen,
    });
    const paxSelectorDesktopClassNames = classNames({
        'odf-space-inner-top-m odf-space-inner-left-l odf-space-inner-right-l odf-space-inner-bottom-m ': true,
        'odf-box odf-box-layer odf-popup odf-popup-flex opened': true,
    });

    const inputClassNames = classNames({
        'odf-input odf-text-lg odf-input-m odf-input-inline odf-input-inline-last odf-select odf-space-outer-right-m': true,
        disabled,
    });
    const wrapperClassNames = classNames({
        'focus odf-input-inline-focus': isOpen,
        'odf-input-group': true,
    });

    const close = () => {
        setOpen(false);
    };

    return (
        <div ref={node} data-testid="pax-selector-wrapper">
            <div className={wrapperClassNames} onClick={() => setOpen(!disabled && !isOpen)}>
                <Div className={inputClassNames} data-testid="pax-selector-summary" whiteSpace="nowrap">
                    <CMS id="flightsManager.passengers" values={{ count: pax }} />
                </Div>
                <span className={arrowClassName} />
            </div>
            <Dropdown open={isOpen} onClose={() => setOpen(false)} parentRef={node}>
                <PaxSelectorDesktopEl
                    data-testid="pax-selector-picker"
                    className={paxSelectorDesktopClassNames}
                >
                    <Div width="270px">
                        <ConnectedPaxSelectorContent />
                    </Div>
                    <div className="odf-stroke-primary" />
                    <div className="odf-input-group odf-space-inner-top-m">
                        <ButtonDefault
                            className={`odf-col-span12 ${buttonClassNames('primary', false, false)}`}
                            onClick={close}
                        >{t('search.button.done')}
                        </ButtonDefault>
                    </div>
                </PaxSelectorDesktopEl>
            </Dropdown>
        </div>
    );
};

PaxSelectorDesktop.propTypes = {
    pax: PropTypes.number.isRequired,
    disabled: PropTypes.bool,
};

PaxSelectorDesktop.defaultProps = {
    disabled: false,
};

const mapStateToProps = (state) => ({
    pax: totalPax(state),
});

export const ConnectedPaxSelectorDesktop = connect(mapStateToProps)(PaxSelectorDesktop);
